import { Avatar, Button } from '@mui/material';
import { db } from 'app/firebase';
import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import { selectChat, setCurrentIndex } from 'features/auth/chatSlice';
import { v4 } from 'uuid';
import {
  doc,
  serverTimestamp,
  setDoc,
  Timestamp,
  updateDoc,
} from 'firebase/firestore';
import INftCard from 'interfaces/NftCard.interface';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getRef } from 'utils/Firebase.util';

interface IUserProps {
  avatarSrc: string;
  username: string;
  userId: number;
  data?: INftCard;
}

const divStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
  color: 'white',
  textTransform: 'capitalize',
} as React.CSSProperties;

//Share nft props to firebase

const SingleUserRow: React.FC<IUserProps> = ({
  avatarSrc,
  username,
  data,
  userId,
}) => {
  const authState = useAppSelector(selectAuth);
  const dispatch = useDispatch();
  const chatState = useAppSelector(selectChat);
  const handleSendNft = async () => {
    let dbRef: string | false | undefined;
    if (authState.id) {
      dbRef = await getRef(authState.id, userId);
    }
    const updateFunction = async () => {
      const msgId = v4();
      if (dbRef)
        try {
          await setDoc(doc(db, 'chats', dbRef, 'messages', msgId), {
            nft: { ...data },
            uid: authState.id,
            type: 'nft',
            date: Timestamp.now(),
            id: msgId,
          });
        } catch (error) {
          throw error;
        }
    };
    if (data) {
      if (dbRef) updateFunction();
      else {
        try {
          const msgId = v4();
          await setDoc(
            doc(db, 'chats', `${authState.id}-${userId}`, 'messages', msgId),
            {
              nft: { ...data },
              type: 'nft',
              date: serverTimestamp(),
              uid: authState.id,
              id: msgId,
            }
          );
          await updateDoc(doc(db, 'chats', `${authState.id}-${userId}`), {
            users: [authState.username, username],
            type: 'nft',
            date: serverTimestamp(),
          });
        } catch (error) {
          console.log(error);
        }
      }
    }
    dispatch(
      setCurrentIndex(
        chatState.inboxUsers.findIndex(user => user.user.id === userId)
      )
    );
  };
  return (
    <div style={divStyles}>
      <div style={divStyles}>
        <Avatar src={avatarSrc} alt="user-avatar" />
        <h4>{username}</h4>
      </div>
      <Button onClick={handleSendNft} variant="contained">
        Share
      </Button>
    </div>
  );
};

export default SingleUserRow;
